module.exports = __webpack_public_path__ + "ClientApp/images/content/mobile/Finding-the-Meaning-in-Mourning1.png";